import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 사용자가 등록한 감정기록지 전체 조회
// request data
//  - pid
export function getEmotionRecordsFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/emotion/records',
        method: 'get',
        params: {pid}
    })
}

// 사라진 감정 기록지 조회
export function getEmotionRecordLostFromMomthera({pid}){
    return AxiosInterceptor({
        url: '/emotion/record/lost',
        method: 'get',
        params: {pid}
    })
}

// 감정기록지(이미지) 조회
export function getEmotionRecordImageFromMomthera({sessionNum, pid}) {
    return AxiosInterceptor({
        url: `/emotion/record/image/${sessionNum}`,
        method: 'get',
        params: { pid },
        responseType: 'blob'
    })
}